import { render } from "./toolhelper.vue?vue&type=template&id=8668f264&scoped=true&ts=true"
import script from "./toolhelper.vue?vue&type=script&lang=ts"
export * from "./toolhelper.vue?vue&type=script&lang=ts"

import "./toolhelper.vue?vue&type=style&index=0&id=8668f264&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8668f264"]])

export default __exports__